<template>
  <div>
    <div class="header">
      <h1 class="page-title">充值中心</h1>
    </div>
    <el-card class="box-card">
      <div class="box-title">请选择充值金额</div>
      <div class="main">
        <ul class="clearfix box-content">
          <li class="current">
            <a>50元</a>
          </li>
          <li>
            <a>100元</a>
          </li>
          <li>
            <a>500元</a>
          </li>
          <li>
            <a>1000元</a>
          </li>
          <li>
            <a>5000元</a>
          </li>
          <li>
            <a>10000元</a>
          </li>
          <div class="reBox" v-show="is_custom">
            <el-input
              id="custMoney"
              type="number"
              style="width:130px"
              class="input-new-tag"
              v-if="inputVisible"
              v-model="reInfo.amount"
              @input="getVal()"
              ref="saveTagInput"
              size="large"
            ></el-input>
            <el-button v-else class="button-new-tag" size="small" @click="showInput">自定义金额</el-button>
          </div>
        </ul>
        <div class="pay-methods">
          <div class="box-title discount" style="display: none;color: #a77c5a;">充值优惠{{discount}}</div>
          <div class="box-title">请选择充值方式</div>
          <div class="methods">
            <ul class="clearfix zhifufangshi">
              <li id="2" v-if="AliPay">
                <a href="javascript:void(0);">
                  <img src="../../../assets/order/Alipay.png" alt="支付宝支付" />
                </a>
              </li>
              <li id="3" v-if="WeChatPay">
                <a href="javascript:void(0);">
                  <img src="../../../assets/order/weChat.png" alt="微信支付" />
                </a>
              </li>
              <li id="4" v-if="ZxPay">
                <a href="javascript:void(0);">
                  <img src="../../../assets/order/ZxPay.png" alt="银联支付" />
                </a>
              </li>

            </ul>
          </div>
        </div>
        <div class="clearfix">
          <button class="sy-ZHBtn" @click="zhifu()">确定支付</button>
        </div>
      </div>
      <!--  -->
                <el-dialog
                title="银联扫码支付"
                :visible.sync="zxpayVisible"
                 width="30%">
                  <div  style="margin: 0 auto;text-align: center;" >
                    <template>
                      <div style="margin: 0 auto;">
                       <img  :src="zxpayimg" width="250px" height="250px">

                        </div>
      <div>
        <span>请用支付宝,微信,云闪印扫描支付</span>
      </div>

                    </template>

                  </div>

                  <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="zxzhifu()">已支付</el-button>
                    <el-button @click="goorder()">重新支付</el-button>

                  </span>
                </el-dialog>
    </el-card>
  </div>

</template>

<script>
export default {
  data() {
    return {
      inputVisible: false,
      reInfo: {
        token: window.localStorage.getItem('token'),
        amount: '0',
        payway: '0',
        order_money: '0'
      },
      zxpayVisible: false,
      zxpayimg: '',
      WeChatPay: false,
      AliPay: false,
      ZxPay: false,
      discount: '',
      is_custom: false

    }
  },
  created() {
    if (!window.localStorage.getItem('token')) {
      this.$router.replace('/login')
      return
    }
    this.queryPayMethods()
  },
  methods: {
    // 用户余 额
    async getYue() {
      let param = new URLSearchParams()
      param.append('token', window.localStorage.getItem('token'))
      const { data: res } = await this.$http({
        method: 'post',
        url: 'api/mine/index',
        data: param
      })
      if (res.data.factory_id == 19) {
        this.ZxPay = true
        this.aliPay = false
        this.reInfo.payway = 4
      }
      this.is_custom = res.data.is_custom
      $('.zhifufangshi li').eq(0).addClass('current')
      if ($('.zhifufangshi li').length < 1) {
        $('.zhifufangshi').html('<li id ="0" class="current"><a style="font-size:30px">请联系客服充值!</a></li>')
      }
      $('.money span').text(res.data.money + '元')
    },
    showInput() {
      $('.box-content li').removeClass('current')
      this.inputVisible = true
      this.reInfo.amount = ''
      this.reInfo.order_money = ''
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    getVal() {
      this.reInfo.order_money = this.reInfo.amount
    },
    // 查询中心订单是否支付了
    async zxqueryOrder(order_pid) {
      let param = new URLSearchParams()
      param.append('token', window.localStorage.getItem('token'))
      param.append('order_pid', order_pid)
      const { data: res } = await this.$http.post('api/pays/zxqueryRecharge', param)
      if (res.code == 1) {
        this.zxpayVisible = false
        window.history.go(0)
      } else {
        setTimeout(() => {
           this.zxqueryOrder(order_pid)
        }, 1000)
      }
    },
    // 支付
    async zhifu() {
      let amount = $('.box-content .current').children('a')
           .text()
           .trim()
           this.reInfo.amount = amount.substr(0, amount.length - 1)
           if (!amount) {
             this.reInfo.amount = $('#custMoney').val().trim()
           }
      this.reInfo.order_money = this.reInfo.amount
       this.reInfo.payway = $('.zhifufangshi .current').attr('id')

console.log(this.reInfo.payway)
      if (this.reInfo.payway == '' || !this.reInfo.payway || this.reInfo.payway == 0) {
        this.$confirm('请先选择支付方式', '提示')
        return
      }
      if (this.reInfo.amount == '' || !this.reInfo.amount) {
        this.$confirm('请先选择充值金额', '提示')
        return
      }
      if (this.reInfo.amount <= 0) {
        this.$confirm('金额不能小于0', '提示')
        return
      }

      let param = new URLSearchParams()
      for (let key in this.reInfo) {
        param.append(key, this.reInfo[key])
      }
      const { data: res } = await this.$http({
        method: 'post',
        url: 'api/pays/changemoney',
        data: param
      })
      if (this.reInfo.payway == 4) {
        this.zxpayVisible = true
        this.zxpayimg = res.data.code_img_url
        console.log(res)
        this.zxqueryOrder(res.data.order_pid)
        return
      }
      const div = document.createElement('div')
      div.innerHTML = res // html code
      document.body.appendChild(div)
      document.forms.alipaysubmit.submit()
    },
    async getdiscount() {
          const { data: res } = await this.$http.get('api/index/getdiscount')
          if (res.msg) {
            $('.discount').show()
            this.discount = res.msg
          }
          },
    // 支付方式
    async queryPayMethods() {
      const { data: res } = await this.$http.get('api/index/payway')
      this.WeChatPay = res.data[3]
      this.AliPay = res.data[2]
      this.ZxPay = res.data[4]
this.getYue()
this.getdiscount()
      }
  },
  mounted() {
    const that = this
    this.$nextTick(() => {
      $('.box-content').on('click', 'li', function() {
        $(this)
          .addClass('current')
          .siblings('li')
          .removeClass('current')
        let amount = $(this)
          .children('a')
          .text()
          .trim()
        that.reInfo.amount = amount.substr(0, amount.length - 1)
        that.reInfo.order_money = that.reInfo.amount
        that.inputVisible = false
      })
      $('.pay-methods .methods').on('click', 'li', function() {
        $(this)
          .addClass('current')
          .siblings('li')
          .removeClass('current')
        that.reInfo.payway = $(this).attr('id')
      })
    })
  }
}
</script>

<style lang="less" scoped>
.header {
  margin-bottom: 20px;
  .page-title {
    font-size: 24px;
  }
}
.box-card {
  position: relative;
  width: 80%;
  height: 700px;
  margin-left: 50px;
  .box-title {
    font-size: 14px;
    color: #666;
    margin-bottom: 10px;
  }
  .current {
    background-color: rgb(250, 247, 244);
  }
  .current a {
    color: #a77c5a;
  }
  .current::before {
    content: '\2713';
    position: absolute;
    top: 5px;
    right: 5px;
    display: block;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background-color: rgb(240, 226, 212);
    text-align: center;
    line-height: 18px;
  }
  .box-content {
    li {
      position: relative;
      float: left;
      width: 120px;
      height: 45px;
      line-height: 45px;
      margin-right: 30px;
      margin-bottom: 20px;
      box-shadow: 0px 0px 3px 1px #ccc;
      text-align: center;
      cursor: pointer;
    }
    .reBox {
      float: left;
      width: 130px;
      height: 50px;
      line-height: 50px;
      .el-button--small {
        padding: 16px 20px;
      }
    }
    #custMoney {
      background-color: red !important;
    }
  }
  .pay-methods {
    .methods {
      ul {
        li {
          float: left;
          position: relative;
          margin-right: 30px;
          width: 180px;
          height: 72px;
          box-shadow: 1px 1px 6px 2px #eee;
          cursor: pointer;
          a {
            display: block;
            width: 100%;
            height: 100%;
            text-align: center;
            line-height: 72px;
          }
        }
      }
    }
  }
  .sy-ZHBtn {
    position: absolute;
    bottom: 50px;
    right: 80px;
    width: 180px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    background-color: #a77c5a;
    color: #fff;
    font-size: 18px;
    border-radius: 3px;
  }
}
</style>
